import { runOwsRequestWithMonitor, Feature, flatten } from '../../../../shared';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import {
    ItemId,
    MoveItemJsonResponse,
    ItemInfoResponseMessage,
    getServiceAsync,
} from '../../../../service';

export function moveContactsOperation(
    personaIds: string[],
    toFolderId: string,
    additionalLogProperties?: {}
): Promise<MoveItemsResults> {
    return getServiceAsync().then(service => {
        const personaIdsObjects = personaIds.map(personaId =>
            service.Factory.itemId({ Id: personaId })
        );
        const targetFolderID = service.Factory.targetFolderId({
            BaseFolderId: service.Factory.folderId({ Id: toFolderId }),
        });
        const body = service.Factory.moveItemRequest({
            ItemIds: personaIdsObjects,
            ToFolderId: targetFolderID,
        });
        const jsonRequest = {
            Header: getJsonRequestHeader(),
            Body: body,
        };
        return runOwsRequestWithMonitor({
            scenarioName: 'MoveContacts',
            feature: Feature.MoveContacts,
            operation: () => service.Operation.moveItemOperation(jsonRequest),
            transformResponse: (response: MoveItemJsonResponse): MoveItemsResults => {
                const movedItems = response.Body.ResponseMessages
                    .Items as ItemInfoResponseMessage[];
                const movedItemIds = flatten(
                    movedItems.map(item => item.Items.map(movedItem => movedItem.ItemId))
                );
                return { ItemIds: personaIdsObjects, nextItemIds: movedItemIds };
            },
            qoSConfig: additionalLogProperties && {
                additionalQoSLogProperty: additionalLogProperties,
            },
        });
    });
}

export type MoveItemsResults = {
    ItemIds: ItemId[];
    nextItemIds: ItemId[];
};
